export const BASE_URL = process.env.REACT_APP_BASE_API
  ? process.env.REACT_APP_BASE_API
  : "https://infocomp.ba";
export const API_BASE_URL = BASE_URL + "/api";

// SLIKE
export const API_IMAGES_URL = BASE_URL + "/images/";
export const GACODE = process.env.REACT_APP_GACODE;
// export const GACODE = "G-2DTY8VRY9Z";
